import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

export default function AlertMsg({ handleClose, open, errMsgDialog, }) {
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle style={{ color: '#4682B4' }}>ส่งข้อมูลไป SAP</DialogTitle>
      <DialogContent dividers>
        <p style={{ margin: 10 }}>{errMsgDialog}</p>
      </DialogContent>
    </Dialog>
  );
}
